import { configureStore } from '@reduxjs/toolkit';
import LoadingReducer from './reducers/loading.reducer';


export default configureStore({
  reducer: {
    loading: LoadingReducer,
  },
});
